/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_Home_EyebrowInputs */

const en_brand_home_eyebrow = /** @type {(inputs: Brand_Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your next step`)
};

const id_brand_home_eyebrow = /** @type {(inputs: Brand_Home_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu langkah berikutnya`)
};

/**
* | output |
* | --- |
* | "Your next step" |
*
* @param {Brand_Home_EyebrowInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const brand_home_eyebrow = /** @type {((inputs?: Brand_Home_EyebrowInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_Home_EyebrowInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brand_home_eyebrow(inputs)
	return en_brand_home_eyebrow(inputs)
});